import { render, staticRenderFns } from "./VotingAgeChart.vue?vue&type=template&id=7feb7039&"
import script from "./VotingAgeChart.vue?vue&type=script&lang=js&"
export * from "./VotingAgeChart.vue?vue&type=script&lang=js&"
import style0 from "./VotingAgeChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports